endpointTypes